// extracted by mini-css-extract-plugin
module.exports = {"statusesSection":"_3S_bX","titre":"_2I9_9","description":"_1sr-D","link":"_2oYtL","icon":"_2XgQi"};